import { render, staticRenderFns } from "./zbindex.vue?vue&type=template&id=0a68995e&scoped=true"
import script from "./zbindex.vue?vue&type=script&lang=js"
export * from "./zbindex.vue?vue&type=script&lang=js"
import style0 from "./zbindex.vue?vue&type=style&index=0&id=0a68995e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68995e",
  null
  
)

export default component.exports